// Unified confirmation: uses Telegram popup if available, otherwise window.confirm
export async function confirmWA(opts: {
  title?: string;
  message: string;
  okText?: string;
  cancelText?: string;
}): Promise<boolean> {
  const wa = (window as any)?.Telegram?.WebApp;
  if (wa?.showPopup) {
    return new Promise((resolve) => {
      wa.showPopup(
        {
          title: opts.title ?? "Confirm",
          message: opts.message,
          buttons: [
            { id: "ok", type: "default", text: opts.okText ?? "OK" },
            { type: "cancel", text: opts.cancelText ?? "Cancel" },
          ],
        },
        (id?: string) => resolve(id === "ok")
      );
    });
  }
  return Promise.resolve(window.confirm(opts.message));
}
